document.addEventListener('DOMContentLoaded', () => {
  const openBtns = document.querySelectorAll('[data-open-currency-modal]');
  const closeBtns  = document.querySelectorAll('[data-close-currency-modal]');
  const modal      = document.getElementById('CurrencyModal');
  const menu   = document.getElementById('mobile-menu');
  const toggle = document.getElementById('mobile-menu-toggle');
  const bg     = document.getElementById('black-bg');
  

  
  if (!openBtns || !modal) return;

  function openModal() {
    modal.hidden = false;
    modal.classList.add('is-open');
  }

  function closeModal() {
    modal.hidden = true;
    modal.classList.remove('is-open');
  }

  function closeNav() {
  menu.classList.remove('is-open');
  toggle.classList.remove('open');
  bg.classList.remove('open');
  menu.setAttribute('aria-hidden', 'true');
}

// Loop and bind the click handler:
openBtns.forEach(openBtn => {
  openBtn.addEventListener('click', e => {
    e.preventDefault();
    openModal();   // your existing currency‐modal toggle
    closeNav();    // **this** will hide the navbar if it was open
  });
});

  closeBtns.forEach(btn =>
    btn.addEventListener('click', closeModal)
  );

  // **Close when clicking on the backdrop**
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const toggle         = document.getElementById('currency-toggle');
  const panel          = document.getElementById('currency-panel');
  const overlay        = document.getElementById('currency-overlay');
  const toggleInput    = document.getElementById('currency-search');
  const displayValue   = toggle.querySelector('.currency-selector__value');
  const hiddenCountry  = document.querySelector('input[name="country_code"]');
  const hiddenCurrency = document.querySelector('input[name="currency"]');
  let prevOption       = toggleInput.value;
  let PrevdisplayValue = displayValue.textContent;

  // grab the list items once
  const items = panel.querySelectorAll('.currency-selector__item');

  // filter helper
  function filterList(term) {
    const q = term.trim().toLowerCase();
    items.forEach(item => {
      const name = item.dataset.name.toLowerCase();
      const code = item.dataset.code.toLowerCase();
      item.style.display = (name.includes(q) || code.includes(q)) ? '' : 'none';
    });
  }

  function openPicker() {
    toggle.setAttribute('aria-expanded', 'true');
    panel.hidden   = false;
    overlay.hidden = false;

    // clear & enable the input
    toggleInput.value       = '';
    toggleInput.disabled    = false;
    displayValue.textContent = '';
    toggleInput.focus();

    // reset list
    filterList('');
  }

  function closePicker() {
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden   = true;
    overlay.hidden = true;

    // disable & restore if nothing chosen
    toggleInput.disabled = true;
    if (toggleInput.value === '') {
      toggleInput.value       = prevOption;
      displayValue.textContent = PrevdisplayValue;
    }
  }

  // when they type, filter:
  toggleInput.addEventListener('input', e => {
    filterList(e.target.value);
  });

  // Toggle on button click
  toggle.addEventListener('click', e => {
    e.stopPropagation();
    panel.hidden ? openPicker() : closePicker();
  });

  // Close on overlay click
  overlay.addEventListener('click', closePicker);

  // Close if clicking anywhere else
  document.addEventListener('click', e => {
    if (!panel.hidden && !panel.contains(e.target) && e.target !== toggle) {
      closePicker();
    }
  });

  // Handle selecting an item
  items.forEach(item => {
    item.addEventListener('click', () => {
      hiddenCountry.value  = item.dataset.code;
      hiddenCurrency.value = item.dataset.symbol;

      const code   = item.dataset.code;
      const symbol = item.dataset.symbol;
      const name   = item.dataset.name;

      prevOption       = name;
      PrevdisplayValue = `${symbol} ${code}`;

      toggleInput.value       = name;
      displayValue.textContent = `${symbol} ${code}`;
      closePicker();
    });
  });
});


